import { Loader2 } from 'lucide-react';

export default function Loading({
    isLoading,
}: {
    isLoading: boolean;
    showImmediate?: boolean;
}) {
    if (!isLoading) {
        return null;
    }

    return (
        <div className="flex items-center justify-center py-12">
            <Loader2 className="size-4 animate-spin text-muted-foreground" />
            <span className="sr-only">Loading...</span>
        </div>
    );
}
